import { Loader2 } from "lucide-react";
import { Skeleton } from "./skeleton";

interface LoadingStateProps {
  message?: string;
  variant?: "spinner" | "skeleton" | "inline";
  className?: string;
  skeletonLines?: number;
}

export function LoadingState({ message = "로딩 중...", variant = "spinner", className, skeletonLines = 3 }: LoadingStateProps) {
  if (variant === "skeleton") {
    return (
      <div className={`space-y-3 ${className || ""}`}>
        {Array.from({ length: skeletonLines }).map((_, i) => (
          <Skeleton key={i} className={`h-4 w-${i === 0 ? "3/4" : "full"}`} />
        ))}
      </div>
    );
  }
  if (variant === "inline") {
    return <Loader2 className={`animate-spin ${className || "w-4 h-4"}`} />;
  }
  return (
    <div className={`flex flex-col items-center justify-center py-12 ${className || ""}`}>
      <Loader2 className="w-8 h-8 animate-spin text-muted-foreground mb-4" />
      <p className="text-sm text-muted-foreground">{message}</p>
    </div>
  );
}
